module.exports = __webpack_public_path__ + "static/media/player-attacking.2ea62638.mp3";